import React, { useState, useEffect } from 'react'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle'
import * as E from './accordionElements'
import { Icon } from 'icons'

const AccordionToggle = ({
  children,
  eventKey,
  defaultActive,
  as,
  expandAccordion,
  readerText,
  hasTabs,
}) => {
  const [isActive, setIsActive] = useState(defaultActive)
  const Component = as || 'div'
  useEffect(() => {
    hasTabs && decoratedOnClick()
  }, [])
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    setIsActive(!isActive)
  })

  return (
    <Component
      onClick={decoratedOnClick}
      className="toggle"
      eventkey={eventKey}
    >
      <div>{children}</div>
      {!isActive && (
        <E.AccordionShowButton className="btn-toggle hideIcon">
          Show
          <span>{readerText}</span>
          <Icon iconType="IconPlus" size={0.8} />
        </E.AccordionShowButton>
      )}
      {isActive && (
        <E.AccordionShowButton className="btn-toggle hideIcon">
          Hide
          <span>{readerText}</span>
          <Icon iconType="IconMinus" size={0.8} />
        </E.AccordionShowButton>
      )}
    </Component>
  )
}

export default AccordionToggle
